import Button from "../Button"
import React, { useCallback, useEffect, useState, type JSX } from "react";
import Overlay from "../Overlay"
import clsx from "clsx"
import { forwardRef } from "react"
import { CloseIcon } from "lib/components/Icon"

interface AlertProps
  extends React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
  > {
  children: React.ReactNode
  onConfirm?: () => void
  onCancel?: () => void
  data?: JSX.Element
  heading?: string
  actions?: []
  cancelText?: string
  confirmText?: string
  showCancel?: boolean
}

const AlertConfirm = React.forwardRef(
  (
    {
      className,
      children,
      heading,
      onConfirm,
      onCancel,
      data,
      showCancel = true,
      cancelText = "Cancel",
      confirmText = "Confirm",
    }: AlertProps,
    ref: React.ForwardedRef<HTMLDivElement>
  ) => {
    const [open, setOpen] = useState(false)

    return (
      <div className="min-w-max">
        <div
          className="cursor-pointer min-w-max"
          ref={ref}
          onClick={() => setOpen(true)}
        >
          {data}
        </div>

        <Overlay show={open} onHide={() => setOpen(false)}>
          <div
            className={clsx("bg-white p-5 min-w-max  rounded-lg ", className)}
          >
            <div className="flex items-center border-b border-gray-300 py-0.5 mb-3">
              <h5 className="mb-2 flex-1 cursor-pointer">{heading}</h5>
              <div onClick={() => setOpen(false)}>
                <CloseIcon />
              </div>
            </div>

            <p className="mb-3">{children}</p>
            <div className="flex flex-row ">
              {showCancel && (
                <Button
                  className="px-4 py-2 mr-2"
                  variant="ERROR"
                  onClick={() => {
                    setOpen(false)
                    onCancel && onCancel()
                  }}
                >
                  {cancelText}
                </Button>
              )}
              <Button
                block={!showCancel}
                className="px-4 py-2"
                variant="PRIMARY"
                onClick={() => {
                  setOpen(false)
                  onConfirm && onConfirm()
                }}
              >
                {confirmText}
              </Button>
            </div>
          </div>
        </Overlay>
      </div>
    )
  }
)

AlertConfirm.displayName = "AlertConfirm"

export default AlertConfirm
